import { Pressable, ScrollView, StyleSheet, Text, View } from 'react-native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import colors from '../theme';
import { RootStackParamList } from '../navigation/RootNavigator';

type Props = NativeStackScreenProps<RootStackParamList, 'CheckEmail'>;

export default function CheckEmailScreen({ navigation }: Props) {
  return (
    <ScrollView contentContainerStyle={styles.container} showsVerticalScrollIndicator={false}>
      <Text style={styles.heading}>Kiểm tra email</Text>
      <View style={styles.illustration}>
        <View style={styles.mailbox} />
        <View style={styles.envelope}>
          <View style={styles.envelopeLine} />
        </View>
      </View>
      <Text style={styles.title}>Chúng tôi vừa gửi email khôi phục mật khẩu cho bạn.</Text>
      <Text style={styles.subtitle}>Nhấn vào liên kết trong email để đặt lại mật khẩu và tiếp tục đăng nhập.</Text>
      <Pressable style={styles.mainButton} onPress={() => navigation.navigate('Login')}>
        <Text style={styles.mainButtonText}>Mở ứng dụng email</Text>
      </Pressable>
      <Text style={styles.description}>Chưa nhận được email? Hãy kiểm tra thư rác hoặc thử lại sau vài phút.</Text>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: colors.background,
    paddingHorizontal: 24,
    paddingTop: 44,
    paddingBottom: 24,
  },
  heading: {
    color: colors.textPrimary,
    fontSize: 20,
    fontWeight: '700',
    marginBottom: 24,
  },
  illustration: {
    height: 190,
    borderRadius: 8,
    backgroundColor: '#BDEBFF',
    marginBottom: 24,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  mailbox: {
    width: 62,
    height: 84,
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: '#4C6FFF',
  },
  envelope: {
    position: 'absolute',
    width: 82,
    height: 54,
    borderRadius: 6,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#DDE4EF',
    bottom: 42,
  },
  envelopeLine: {
    width: 56,
    height: 2,
    borderRadius: 1,
    backgroundColor: colors.button,
    marginTop: 18,
    alignSelf: 'center',
  },
  title: {
    color: colors.textPrimary,
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 10,
  },
  subtitle: {
    color: colors.textSecondary,
    fontSize: 14,
    lineHeight: 16,
    marginBottom: 28,
  },
  mainButton: {
    backgroundColor: colors.button,
    borderRadius: 5,
    paddingVertical: 12,
    alignItems: 'center',
    marginBottom: 18,
  },
  mainButtonText: {
    color: colors.buttonText,
    fontWeight: '700',
    fontSize: 14,
  },
  description: {
    color: colors.textSecondary,
    fontSize: 14,
    lineHeight: 16,
    textAlign: 'center',
  },
});
